import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container_home"
};
const _hoisted_2 = {
  class: "titelimg"
};
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CrooperImg = _resolveComponent("CrooperImg");
  const _component_appHead = _resolveComponent("appHead");
  const _component_picture_compare_carousel = _resolveComponent("picture_compare_carousel");
  const _component_image_show = _resolveComponent("image_show");
  const _component_appbottom = _resolveComponent("appbottom");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_CrooperImg, {
    ref: "cutImg",
    widthheight_ratio: $data.widthheight_ratio,
    onOk: $options.onCropOk,
    onCancel: $options.onCropCancel
  }, null, 8, ["widthheight_ratio", "onOk", "onCancel"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_appHead, {
    index: 0
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.logotitle,
    alt: ""
  }, null, 8, _hoisted_3)]), _createVNode(_component_picture_compare_carousel), _createVNode(_component_image_show, {
    onLoadend: $options.onImagesLoadEnd
  }, null, 8, ["onLoadend"]), _createVNode(_component_appbottom, {
    ref: "bottomImageGenerateAll",
    onStartcrop: $options.startcrop
  }, null, 8, ["onStartcrop"])])], 64);
}